import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import { Actions as ACTIONS, DISCOUNT_TYPE } from "store/coupon/action";
import PageHeading from "components/PageHeading";
import { Link } from "react-router-dom";
import AsyncSelect from "react-select/async";
import { API } from "@aws-amplify/api";
import { listCoupons as listCouponsQuery } from "graphql/queries";
import { selectDefaultStyle } from 'styles/selectDefaultStyle'

const IndicatorsContainer = () => (
  <div style={{ display: "flex", padding: "6.5px" }}>
    <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
      <path
        fillRule="evenodd"
        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
        clipRule="evenodd"
      />
    </svg>
  </div>
);

const Coupons = ({
  coupons,
  couponsNextToken,
  listCoupons,
  locations,
  businessID,
}) => {
  let history = useHistory();

  useEffect(() => {
    if (!coupons) listCoupons(100, couponsNextToken);
  }, []);

  const getLocationName = (locationId) => {
    const location = locations.find((location) => location.id === locationId);
    return location ? location.name : "";
  };

  return (
    <React.Fragment>
      <PageHeading withCreate={true} />

      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="flex flex-col">
          <div className="sm:px-12 lg:px-12" style={{ width: "100%" }}>
            <div className="pt-6 grid grid-cols-12 gap-12">
              <div className="col-span-3 col-start-10">
                <AsyncSelect
                  className="block form-select w-full p-0 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                  styles={selectDefaultStyle}
                  defaultOptions={[]}
                  loadOptions={(inputValue, callback) => {
                    const variables = {
                      businessID,
                      filter: {
                        or: [
                          { code: { beginsWith: inputValue } },
                          { name: { beginsWith: inputValue } },
                        ],
                        and: { enabled: { eq: true } },
                      },
                    };
                    const request = API.graphql({
                      query: listCouponsQuery,
                      variables,
                      authMode: "AMAZON_COGNITO_USER_POOLS",
                    });

                    request.then(({ data }) => {
                      const couponsList = data.listCoupons.items;
                      const options = couponsList?.map((coupon) => ({
                        value: coupon.id,
                        label: `${coupon.name} (${coupon.code}) `,
                        coupon: coupon,
                      }));
                      callback(options);
                    });
                  }}
                  placeholder="Find a coupon..."
                  onChange={(selectedCustomer) => {
                    history.push("/coupon/" + selectedCustomer.value);
                  }}
                  components={{ IndicatorsContainer }}
                />
              </div>
            </div>
          </div>

          <div className="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
            <div className="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200">
              <table className="min-w-full">
                <thead>
                  <tr>
                    <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                      Name
                    </th>
                    {/* <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                      Code
                    </th> */}
                    <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                      Location
                    </th>
                    <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                      Amount
                    </th>
                    <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                      Enabled
                    </th>
                    <th className="px-6 py-3 border-b border-gray-200 bg-gray-50"></th>
                  </tr>
                </thead>
                <tbody className="bg-white">
                  {coupons?.map((coupon) => {
                    if (!coupon._deleted)
                      return (
                        <tr key={coupon.id}>
                          <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 font-medium text-gray-900">
                            {coupon.name}
                          </td>
                          {/* <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500">
                            {coupon.code}
                          </td> */}
                          <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500">
                            {getLocationName(coupon.locationID)}
                          </td>
                          <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500">
                            {coupon.amount}
                            {coupon.discountType === DISCOUNT_TYPE.PERCENTAGE
                              ? "%"
                              : ""}
                          </td>
                          <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500">
                            <div className="ml-2 flex-shrink-0 flex">
                              {coupon.enabled ? (
                                <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                                  Yes
                                </span>
                              ) : (
                                <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800">
                                  No
                                </span>
                              )}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-no-wrap text-right border-b border-gray-200 text-sm leading-5 font-medium">
                            <Link
                              to={`/coupon/${coupon.id}`}
                              className="text-indigo-600 hover:text-indigo-900 focus:outline-none focus:underline"
                            >
                              Edit
                            </Link>
                          </td>
                        </tr>
                      );
                  })}
                  {couponsNextToken && (
                    <tr>
                      <td
                        onClick={() => listCoupons(100, couponsNextToken)}
                        className="cursor-pointer px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500 text-center"
                        colSpan={7}
                      >
                        Load More
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    coupons: state.coupon.list,
    couponsNextToken: state.coupon.listNextToken,
    locations: state.location.list,
    businessID: state.businessID,
  };
};

const mapDispatchToProps = (dispatch) => ({
  listCoupons: (limit, nextToken) =>
    dispatch(ACTIONS.getList(limit, nextToken)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Coupons);
